import { render } from "./DocumentNavigationSigneesAdd.vue?vue&type=template&id=70c86016&scoped=true"
import script from "./DocumentNavigationSigneesAdd.vue?vue&type=script&lang=js"
export * from "./DocumentNavigationSigneesAdd.vue?vue&type=script&lang=js"

import "./DocumentNavigationSigneesAdd.vue?vue&type=style&index=0&id=70c86016&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c86016"]])

export default __exports__